// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"SocialLinks_socialLinks__11KyV"};